module.exports = __webpack_public_path__ + "static/media/re5.2028611e.png";